import * as React from "react";

import primaryColour from "../constants";

function SvgDot(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width={6} height={6} viewBox="0 0 6 6" fill="none" {...props}>
      <rect width={5.88889} height={6} rx={2.94444} fill={fill} />
    </svg>
  );
}

export default SvgDot;
